import { render, staticRenderFns } from "./static-text-widget.vue?vue&type=template&id=70ac3194&scoped=true"
import script from "./static-text-widget.vue?vue&type=script&lang=js"
export * from "./static-text-widget.vue?vue&type=script&lang=js"
import style0 from "./static-text-widget.vue?vue&type=style&index=0&id=70ac3194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ac3194",
  null
  
)

export default component.exports